var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 8 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M6.335 0L7.75 1.415 3.08 6.002l4.67 4.583L6.335 12 .25 6.002 6.335 0z","fill":"#974900"}})])}
var staticRenderFns = []

export { render, staticRenderFns }